import { axiosInstance as axios } from "../../api/axios";

function getHeaders() {
  let token = localStorage.getItem("jwt");
  const headers = {
    "Access-Control-Allow-Origin": "*",
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  return headers;
}

async function getRecipes() {
  let status;
  let response;
  const header = getHeaders();
  await axios
    .get("recipes", {
      headers: header,
    })
    .then((res) => {
      status = res.status;
      response = res.data;
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status) {
          status = error.response.status;
        }
      }
    });
  return { status: status, response: response };
}
async function getRecipe(recipeId) {
  let status;
  let response;
  const header = getHeaders();
  await axios
    .get(`recipes/${recipeId}`, {
      headers: header,
    })
    .then((res) => {
      status = res.status;
      response = res.data;
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status) {
          status = error.response.status;
        }
      }
    });
  return { status: status, response: response };
}

async function handleRecipeDecision(recipeIssue, observation, decision) {
  const header = getHeaders();
  let status;
  let isRejected;
  switch (decision) {
    //value:0; ACEPTADA
    case 0: {
      isRejected = false;
      break;
    }
    //value:1; RECHAZADA
    case 1:
      isRejected = true;
      break;
  }
  await axios
    .post(
      `recipes/handle-recipe-decision`,
      {
        recipeIssue: recipeIssue,
        observation: observation,
        isRejected: isRejected,
      },
      {
        headers: header,
      }
    )
    .then((res) => {
      status = res.status;
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status) {
          status = error.response.status;
        }
      }
    });
  return status;
}

export { getRecipes, getRecipe, handleRecipeDecision };
